<template>
  <OrModalV3
    :is-open="isOpen"
    size="m"
    data-test="queue-monitoring-modal"
    @close="$emit('close')"
  >
    <queue-monitoring-form
      :metric-data="metricData"
      :is-loading="isLoading"
      @update-params="$emit('updateParams', $event)"
    />
    <template #header>
      {{ $t('monitoringModal.title') }}
    </template>
    <template #footer>
      <div
        class="flex items-center justify-end gap-[16px]"
      >
        <OrButtonV3
          variant="outlined"
          data-test="close-monitoring-modal"
          @click="$emit('close')"
        >
          {{ $t('common.close') }}
        </OrButtonV3>
      </div>
    </template>
  </OrModalV3>
</template>
<script lang="ts">
import { OrButtonV3, OrModalV3 } from '@onereach/ui-components';
import { defineComponent, PropType } from 'vue';
import QueueMonitoringForm from './QueueMonitoringForm.vue';
import { MetricData } from '@/types';

export default defineComponent({
  name: 'QueueMonitoringModal',
  components: {
    OrModalV3,
    OrButtonV3,
    QueueMonitoringForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    metricData: {
      type: Array as PropType<MetricData[]>,
      required: true,
    },
  },
  emits: ['close', 'updateParams'],
});
</script>
